import { Head } from "@inertiajs/react";
import { BookOpen } from "lucide-react";
import SchoolLayout from "@/components/schools/SchoolLayout";
import EmptyState from "@/components/EmptyState";

/**
 * Shown to a teacher with no classroom — at all, or in the campaign they
 * picked in the campaign picker (`campaign_name`). Deliberately carries
 * no school-wide financials or admin data: a teacher is not an admin.
 */
export default function Unassigned({ school, membership, campaign_name }) {
  return (
    <SchoolLayout school={school} membership={membership} eyebrow={campaign_name} title="No classroom yet">
      <Head title={`My classroom · ${school.name}`} />

      <EmptyState
        icon={BookOpen}
        title={campaign_name ? `You don't have a classroom in ${campaign_name}` : "You haven't been added to a classroom yet"}
        description="Ask your school admin to add you to your classroom. Once they do, your class's reading minutes, prizes and leaderboard show up here."
      />
    </SchoolLayout>
  );
}
